var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "OH-code" }, [
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c("section", { staticClass: "OH-code-content" }, [
        _c(
          "div",
          {
            staticClass: "courseBox",
            on: {
              mouseover: function($event) {
                _vm.playBlockyG()
              },
              mouseleave: function($event) {
                _vm.playBlockyJ()
              }
            }
          },
          [
            _c("img", { attrs: { src: _vm.playBlocky } }),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "blocky",
                on: {
                  click: function($event) {
                    _vm.to_OHC(0, 123001, "OHblocky")
                  }
                }
              },
              [_vm._v("\n            进入积木模式\n          ")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "courseBox",
            on: {
              mouseover: function($event) {
                _vm.playPythonG()
              },
              mouseleave: function($event) {
                _vm.playPythonJ()
              }
            }
          },
          [
            _c("img", { attrs: { src: _vm.playPython } }),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "py",
                on: {
                  click: function($event) {
                    _vm.to_OHC(1, 123002, "OHpython")
                  }
                }
              },
              [_vm._v("\n            进入Python模式\n          ")]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nav" }, [
      _c("img", {
        staticStyle: { "margin-right": "85px" },
        attrs: { src: require("../assets/logo.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("p", [
        _c("a", { attrs: { href: "https://www.icode.org.cn/" } }, [
          _vm._v("首页")
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _c("a", { attrs: { href: "https://www.icode.org.cn/raceCenter" } }, [
          _vm._v("赛事")
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _c("a", { attrs: { href: "https://www.icode.org.cn/certificate" } }, [
          _vm._v("证书")
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _c("a", { attrs: { href: "https://www.icode.org.cn/aboutus" } }, [
          _vm._v("关于我们")
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _c("a", { attrs: { href: "https://www.icode.org.cn/racePartner" } }, [
          _vm._v("赛事伙伴")
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _c(
          "a",
          {
            staticStyle: { color: "#148bff" },
            attrs: { href: "javascript:;" }
          },
          [_vm._v("编程一小时")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("p", { staticClass: "title" }, [
        _c("i", { staticClass: "icons" }),
        _vm._v(" "),
        _c("span", [_vm._v("ICode编程一小时")]),
        _vm._v(" "),
        _c("i", { staticClass: "icons" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "OH-code-title" }, [
      _c("h1", { staticStyle: { "font-size": "30px" } }, [
        _vm._v("完成10个关卡，即可获得“编程一小时”证书")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "OH-code-link" }, [
        _c(
          "a",
          { attrs: { href: "https://t.1yb.co/bKCO", target: "_blank" } },
          [
            _c("span", [
              _c("i", { staticClass: "el-icon-question" }),
              _vm._v("什么是“编程一小时”活动？")
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [_vm._v("无需输入代码")]),
      _vm._v(" "),
      _c("li", [_vm._v("拖动积木即可完成编程")]),
      _vm._v(" "),
      _c("li", [_c("b", [_vm._v("建议1-3年级学生使用")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [_vm._v("使用Python语法进行编程")]),
      _vm._v(" "),
      _c("li", [_vm._v("掌握人工智能明星语言")]),
      _vm._v(" "),
      _c("li", [_c("b", [_vm._v("建议4年级及以上学生使用")])])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9ea92550", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ea92550","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ohcIndex.vue
// module id = null
// module chunks = 